import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const mbtiRoutes: CustomRouteRecordRaw = {
  path: 'mbti',
  name: 'mbti',
  component: EmptyLayout,
  redirect: { name: 'workbench' },
  meta: {
    title: 'MBTI性格测试',
    iconfont: 'icon-user-heart-line',
    requiredPermission: 'mbti'
  },
  children: [
    {
      path: 'mbti-test-list',
      name: 'mbtiTestList',
      component: () => import('@/views/mbti/mbti-test-list.vue'),
      meta: {
        title: '测评记录',
        requiredPermission: 'mbti.test.list'
      },
    },
    {
      path: 'mbti-test-report',
      name: 'mbtiTestReport',
      component: () => import('@/views/mbti/mbti-test-report.vue'),
      meta: {
        title: '报告列表',
        requiredPermission: 'mbti.test.report'
      },
    },
  ],
}
